import axios from "axios";
import { request } from "@/utils/request";

/**
 * 查询
 * @param {*} data
 * @returns
 */
export function selectAdmin(data) {
  return request({
    url: `/administrator/selectUser`,
    method: "POST",
    data,
  });
}
/**
 * 用户查询自己管理的账号
 * @param {*} data
 * @returns
 */
export function selectById(data) {
  return request({
    url: `/administrator/selectById`,
    method: "POST",
    data,
  });
}
/**
 * 新增
 * @param {*} data
 * @returns
 */
export function addAdmin(data) {
  return request({
    url: `/administrator/add`,
    method: "POST",
    data,
  });
}

/**
 * 手动新增账号
 * @param {*} data
 * @returns
 */
export function addAdminManual(data) {
  return request({
    url: `/administrator/addAdmin`,
    method: "POST",
    data,
  });
}

/**
 * 更改用户信息
 * @param {*} data
 * @returns
 */
export function updateAdmin(data) {
  return request({
    url: `/administrator/updateUser`,
    method: "POST",
    data,
  });
}

/**
 * 更改密码
 * @param {*} data
 * @returns
 */
export function updatePassword(data) {
  return request({
    url: `/administrator/updatePassword`,
    method: "POST",
    data,
  });
}


/**
 * 编辑权限
 * @param {*} data
 * -role_id
 * @returns
 */
export function updateRole(data) {
  return request({
    url: `/administrator/updateRole`,
    method: "POST",
    data,
  });
}

/**
 * 删除
 * @param {*} data
 * @returns
 */
export function deleteAdmin(data) {
  return request({
    url: `/administrator/delete`,
    method: "POST",
    data,
  });
}


/**
 * 查询角色
 * @param {*} data
 * @returns
 */
export function selectAuthGroup(data) {
  return request({
    url: `/administrator/selectAuthGroupList`,
    method: "POST",
    data,
  });
}

/* 查看调解员列表 */
export function selectMediator(data) {
  return request({
    url: `/administrator/selectMediator`,
    method: "POST",
    data
  });
}

